export const CONSTANTS_PAYMENTGATEWAYS = {
  countries: [
    {
      "name": "India",
      "country_code": "IND",
      "payment_gateways": [
        {
          "pgw_name": "RazorpayIndia",
          "logo": "/assets/img/logo-razorpay.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 1,
          "signup_url": ""
        }
      ]
    },
    {
      "name": "United States",
      "country_code": "USA",
      "payment_gateways": [
        {
          "pgw_name": "PayenginUSA",
          "logo": "/assets/img/logo-payengine.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": false,
          "is_depricated": false,
          "id": 2,
          "signup_url": ""
        },
        {
          "pgw_name": "StripeUSA",
          "logo": "/assets/img/stripe.jpg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 13,
          "signup_url": ""
        }
      ]
    },
    {
      "name": "Australia",
      "country_code": "AUS",
      "payment_gateways": [
        {
          "pgw_name": "EzypayAustralia",
          "logo": "/assets/img/logo-ezypay.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "supports_pos_terminal": true,
          "id": 6,
          "signup_url": "https://ezypay.com/application-fitnessforce/au"
        }
      ]
    },
    {
      "name": "Singapore",
      "country_code": "SGP",
      "payment_gateways": [
        {
          "pgw_name": "EzypaySingapore",
          "logo": "/assets/img/logo-ezypay.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 7,
          "signup_url": "https://ezypay.com/application-fitnessforce/au"
        }
      ]
    },
    {
      "name": "Malaysia",
      "country_code": "MYS",
      "payment_gateways": [
        {
          "pgw_name": "EzypayMalaysia",
          "logo": "/assets/img/logo-ezypay.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 8,
          "signup_url": "https://ezypay.com/application-fitnessforce/au"
        }
      ]
    },
    {
      "name": "Philippines",
      "country_code": "PHL",
      "payment_gateways": [
        {
          "pgw_name": "EzypayPhilippines",
          "logo": "/assets/img/logo-ezypay.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 9,
          "signup_url": "https://ezypay.com/application-fitnessforce/au"
        }
      ]
    },
    {
      "name": "Canada",
      "country_code": "CAN",
      "payment_gateways": [
        {
          "pgw_name": "PayenginCanada",
          "logo": "/assets/img/logo-payengine.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": false,
          "is_depricated": false,
          "id": 11,
          "signup_url": ""
        },
        {
          "pgw_name": "StripeCanada",
          "logo": "/assets/img/stripe.jpg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 12,
          "signup_url": ""
        }
      ]
    },
    {
      "name": "Saudi Arabia",
      "country_code": "SAU",
      "payment_gateways": [
        {
          "pgw_name": "TapSaudi",
          "logo": "/assets/img/logo-tap.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 14,
          "signup_url": ""
        }
      ]
    },
    {
      "name": "United Arab Emirates",
      "country_code": "ARE",
      "payment_gateways": [
        {
          "pgw_name": "TapUAE",
          "logo": "/assets/img/logo-tap.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": false,
          "is_depricated": false,
          "id": 15,
          "signup_url": ""
        },
        {
          "pgw_name": "StripeUAE",
          "logo": "/assets/img/stripe.jpg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 20,
          "signup_url": ""
        }
      ]
    },
    {
      "name": "Kuwait",
      "country_code": "KWT",
      "payment_gateways": [
        {
          "pgw_name": "TapKuwait",
          "logo": "/assets/img/logo-tap.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 16,
          "signup_url": ""
        }
      ]
    },
    {
      "name": "Oman",
      "country_code": "OMN",
      "payment_gateways": [
        {
          "pgw_name": "TapOman",
          "logo": "/assets/img/logo-tap.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 17,
          "signup_url": ""
        }
      ]
    },
    {
      "name": "Bahrain",
      "country_code": "BHR",
      "payment_gateways": [
        {
          "pgw_name": "TapBahrain",
          "logo": "/assets/img/logo-tap.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 18,
          "signup_url": ""
        }
      ]
    },
    {
      "name": "Egypt",
      "country_code": "EGY",
      "payment_gateways": [
        {
          "pgw_name": "TapEgypt",
          "logo": "/assets/img/logo-tap.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 19,
          "signup_url": ""
        }
      ]
    },
    {
      "name": "Norway",
      "country_code": "NOR",
      "payment_gateways": [
        {
          "pgw_name": "StripeNorway",
          "logo": "/assets/img/stripe.jpg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 9,
          "signup_url": ""
        }
      ]
    },
    {
      "name": "Lebanon",
      "country_code": "LBN",
      "payment_gateways": [
        {
          "pgw_name": "TapLebanon",
          "logo": "/assets/img/logo-tap.svg",
          "description": "Supports both one time and recurring.",
          "is_recomended": true,
          "is_depricated": false,
          "id": 21,
          "signup_url": ""
        }
      ]
    },
  ]
}